import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import Snackbar from 'material-ui/Snackbar'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'

const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
  root: {
    backgroundColor: theme.palette.primary.light,
  },
})

class SimpleSnackbar extends React.Component {

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.props.hideMessage()
  }

  render() {
    const {classes, show, message} = this.props
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={show}
        autoHideDuration={15000}
        onClose={this.handleClose}
        SnackbarContentProps={{'aria-describedby': 'message-id', classes: {root: classes.root}}}
        message={<span id="message-id">{message}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={this.handleClose}
          >
            <CloseIcon/>
          </IconButton>,
        ]}
      />
    )
  }
}

SimpleSnackbar.propTypes = {
  show: PropTypes.bool.isRequired,
  hideMessage: PropTypes.func.isRequired,
}

export default withStyles(styles)(SimpleSnackbar)



// WEBPACK FOOTER //
// ./src/common/components/SimpleSnackbar.js